import React, { useState, useMemo, useRef } from 'react';

export const AccordionPanel = (props) => props;

const focusFirstPanelItem = (panelId) => {
    document
        .getElementById(panelId)
        ?.querySelector(
            'input:not([type="hidden"]), button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
        ?.focus();
};

export const Accordion = ({ children, className }) => {
    const [index, setIndex] = useState(-1);
    const headerRefs = useRef([]);

    const handleToggleHeader = (itemIndex) => {
        const isOpen = itemIndex === index;
        setIndex((prevIndex) => (prevIndex === itemIndex ? -1 : itemIndex));
        if (!isOpen) {
            setTimeout(
                () => focusFirstPanelItem(`accordion-panel-${itemIndex}`),
                0
            );
        }
    };

    const handleClosePanel = (event, itemIndex) => {
        if (event.key !== 'Escape' || itemIndex !== index) {
            return;
        }
        event.preventDefault();
        setIndex(-1);
        headerRefs.current[itemIndex]?.focus();
    };

    const activeClass = (itemIndex) => (itemIndex === index ? 'active' : '');

    const accordions = useMemo(() => React.Children.toArray(children), [
        children,
    ]);

    const headers = accordions.map((accordion, itemIndex) => {
        const panelId = `accordion-panel-${itemIndex}`;
        const headerId = `accordion-header-${itemIndex}`;
        const isExpanded = itemIndex === index;

        return (
            <div className="columns" key={`accordion__header-${itemIndex}`}>
                <button
                    type="button"
                    ref={(element) => {
                        headerRefs.current[itemIndex] = element;
                    }}
                    id={headerId}
                    className={`accordion__header ${activeClass(itemIndex)} ${
                        accordion.props.icon || ''
                    }`}
                    aria-expanded={isExpanded}
                    aria-controls={panelId}
                    onClick={() => handleToggleHeader(itemIndex)}
                    onKeyDown={(event) => handleClosePanel(event, itemIndex)}
                >
                    {accordion.props.header || ''}
                </button>
            </div>
        );
    });

    const panels = accordions.map((accordion, itemIndex) => (
        <div
            id={`accordion-panel-${itemIndex}`}
            role="region"
            aria-labelledby={`accordion-header-${itemIndex}`}
            className={`accordion__panel ${activeClass(itemIndex)}`}
            key={`accordion__panel-${itemIndex}`}
            hidden={itemIndex !== index}
            onKeyDown={(event) => handleClosePanel(event, itemIndex)}
        >
            {accordion.props.children}
        </div>
    ));

    return (
        <div className={className}>
            <nav className="accordion__header-container">{headers}</nav>
            {panels}
        </div>
    );
};
